import type { CategoryTreeNodeDto } from "@semo/api-contracts";

export interface FlattenedCategoryResult<T> {
  original: T;
  pathName: string;
  fullPath: string; // alias for pathName
}

/**
 * Flattens a category tree into a list, calculating full path names (e.g., "Parent > Child").
 *
 * @param nodes The tree nodes to flatten
 * @returns Array of objects containing the original node and its full path string
 */
export function flattenCategoryTree(
  nodes: CategoryTreeNodeDto[],
): FlattenedCategoryResult<CategoryTreeNodeDto>[] {
  const result: FlattenedCategoryResult<CategoryTreeNodeDto>[] = [];

  const recurse = (list: CategoryTreeNodeDto[], parentPath = "") => {
    for (const node of list) {
      const currentPath = parentPath
        ? `${parentPath} > ${node.name}`
        : node.name;
      result.push({
        original: node,
        pathName: currentPath,
        fullPath: currentPath,
      });

      if (node.children.length > 0) {
        recurse(node.children, currentPath);
      }
    }
  };

  recurse(nodes);
  return result;
}
